import $Translate from './i18n/translations';
import accounting from 'accounting';
import $pluralize from 'pluralize';
import Handlebars from 'handlebars';

Handlebars.registerHelper('i18n', function (...args) {
  return $Translate.putOut(...args);
});

Handlebars.registerHelper('ifEqual', function (leftValue, rightValue, options) {
  if (leftValue == rightValue) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

Handlebars.registerHelper('unlessEqual', function (leftValue, rightValue, options) {
  if (leftValue == rightValue) {
    return options.inverse(this);
  } else {
    return options.fn(this);
  }
});

Handlebars.registerHelper('join', function (array, separator = ',') {
  return array.join(separator);
});

Handlebars.registerHelper('formatMoney', function (price, symbol) {
  return accounting.formatMoney(price, symbol);
});

Handlebars.registerHelper('pluralize_part', (string, count) => {
  if (count == 1 || string.match(/(oil|fluid|coolant|wash|antifreeze)$/i)) {
    return string;
  }
  return $pluralize(string, count);
});

export default Handlebars;
